import { useScrollReveal } from '../../../hooks/useScrollReveal';

const pains = [
  {
    icon: 'ri-time-line',
    title: 'Recrutement trop long',
    description:
      'Entre la recherche, les entretiens et l\'intégration, il faut en moyenne 3 à 6 mois pour recruter un commercial opérationnel. Pendant ce temps, vos opportunités passent.',
    tag: '#1 — Délais',
  },
  {
    icon: 'ri-money-euro-circle-line',
    title: 'Charges fixes étouffantes',
    description:
      'Un commercial en CDI coûte bien plus que son salaire : charges sociales, mutuelle, formation, matériel, management… Un budget que la plupart des TPE/PME ne peuvent pas assumer.',
    tag: '#2 — Coûts',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Pas le temps de prospecter',
    description:
      'Vous gérez la prod, la compta, les clients, l\'administratif… La prospection passe toujours à la trappe. Résultat : votre pipe est vide et la croissance stagne.',
    tag: '#3 — Temps',
  },
];

export default function Probleme() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="probleme" className="bg-white py-24 lg:py-32">
      <div ref={ref} className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block text-[#6ECFA0] text-sm font-bold uppercase tracking-widest mb-4">
            Le vrai problème
          </span>
          <h2 className="text-4xl lg:text-5xl font-black text-[#0A0A0A] leading-tight mb-4">
            Vous perdez du temps{' '}
            <span className="relative inline-block">
              et de l&apos;argent
              <span className="absolute -bottom-1 left-0 w-full h-1 bg-[#6ECFA0] rounded-full" />
            </span>
          </h2>
          <p className="text-lg text-[#555] max-w-xl mx-auto mt-6">
            La plupart des TPE, PME et startups rencontrent les mêmes blocages commerciaux. Voici les 3 principaux.
          </p>
        </div>

        {/* Pain cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {pains.map((pain, i) => (
            <div
              key={pain.title}
              className={`relative bg-[#F9F9F9] border-l-4 border-[#6ECFA0] rounded-2xl p-8 hover:-translate-y-1 transition-all duration-500 ${
                isVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <span className="absolute top-4 right-6 text-xs font-bold text-[#6ECFA0]/40 uppercase tracking-widest">
                {pain.tag}
              </span>
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-[#0A0A0A] mb-6">
                <i className={`${pain.icon} text-2xl text-white`} />
              </div>
              <h3 className="text-xl font-black text-[#0A0A0A] mb-3">{pain.title}</h3>
              <p className="text-[#666] leading-relaxed text-sm">{pain.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom accent */}
        <div
          className={`mt-16 text-center transition-all duration-700 delay-500 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <p className="text-base font-semibold text-[#0A0A0A]">
            Bonne nouvelle :{' '}
            <span className="text-[#6ECFA0]">il existe une alternative flexible, rapide et sans risque.</span>
          </p>
        </div>
      </div>
    </section>
  );
}
